import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';

//Icon
import FavoriteIcon from '@material-ui/icons/Favorite';


class Comp extends React.Component {


	render() {

		return (
      <span className='couple_icon'>
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            cursor:'pointer',
          }}
          onClick={ () => this.props.helpOpen('id',457) }
        >
          <FavoriteIcon />
          <span>カップリング中</span>
        </div>
      </span>
		)
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
